import React, { Component } from 'react';
import WlfComponent from "../components/Wlf";
import { urlParamToObj } from "../../lib/url-util";
import './styles.scss';

class WlfAdmin extends Component {

  render() {
    return (
      <div className="user-page">
        <WlfComponent
          //id={wlf.id}
          bannerMenu={true}
          path={this.props.location.pathname}
          args={urlParamToObj(this.props.location.search)}
          rootPath={"/wlf-admin/clients"}/>
      </div>
    );
  }
}

export default WlfAdmin;
